package api

import kotlinx.serialization.*

@Serializable
data class VisualProperties(
    /** @see api.ResourceType */
    var type: Int,
    var name: String,
    var widthIn: Int,
    var heightIn: Int,
    var durationMsIn: Long,

    var widthOut: Int = widthIn,
    var heightOut: Int = heightIn,
    var durationMsOut: Long = durationMsIn,

    var scale: Int = SCALE_FILL,
    var deleteOrigin: Boolean = true,
) {

    companion object {
        const val SCALE_FILL = 2
        const val SCALE_FIT = 4
        const val SCALE_CROP_CENTER = 8

        @Suppress("unused")
        val scaleVariants by lazy {
            listOf(SCALE_FILL, SCALE_FIT, SCALE_CROP_CENTER)
        }
    }

    @Suppress("unused")
    fun changed(): Boolean {
        return widthIn != widthOut
            || heightIn != heightOut
            || durationMsIn != durationMsOut
            || scale != SCALE_FILL
    }
}
